<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100      
      .form-group.col-md-3.col-2.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            i.fa.fa-search
          DebounceInput(autofocus type="text" v-model="search" :placeholder="$t('ui.search_by_id')" @enter="getRescueFundList(true)" size="sm")
      .form-group.col-md-9.col-10.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getRescueFundList(true)"
          variant="primary"
          size="sm"
        )
      .form-group.col-6.mb-1(v-if="isEditAccess")
        b-button(v-b-modal.addRescueFund type="button" variant="info" size="sm")
          i.fa.fa-plus
          span.ml-1 {{ $t("ui.combine.add_rescue_fund") }}
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)"
        )
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")              
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th.text-left(width="5%" @click="sortOrder('rescue_id')")
                  span(:title="$t('ui.id')") {{ $t('ui.id') }}
                  .float-right 
                    i(:class="changeSortKey('rescue_id')")
                th.text-left(width="7%" @click="sortOrder('rescue_name')")
                  span(:title="$t('ui.name')") {{ $t('ui.name') }}
                  .float-right 
                    i(:class="changeSortKey('rescue_name')")
                th.text-left(width="5%" @click="sortOrder('rescue_cycle')")
                  span(:title="$t('ui.cycle')") {{ $t('ui.cycle') }}
                  .float-right 
                    i(:class="changeSortKey('claimrescue_cycle_type')")
                th.text-right(width="5%" @click="sortOrder('rescue_rate')")
                  span(:title="$t('ui.rate')") {{ $t('ui.rate') }}
                  .float-right 
                    i(:class="changeSortKey('rescue_rate')")
                th.text-right(width="7%" @click="sortOrder('min_lose')")
                  span(:title="$t('ui.min_lose')") {{ $t("ui.min_lose") }}
                  .float-right 
                    i(:class="changeSortKey('min_lose')")
                th.text-right(width="7%" @click="sortOrder('max_payout')")
                  span(:title="$t('ui.max_payout')") {{ $t("ui.max_payout") }}
                  .float-right 
                    i(:class="changeSortKey('max_payout')")
                th.text-left(width="10%")
                  span(:title="$t('ui.provider_list')") {{ $t("ui.provider_list") }}
                th.text-left(width="10%" @click="sortOrder('payout_method')")
                  span(:title="$t('ui.payout_method')") {{ $t("ui.payout_method") }}
                  .float-right 
                    i(:class="changeSortKey('payout_method')")
                th.text-left(width="9%" @click="sortOrder('campaign_id')")
                  span(:title="$t('ui.campaign_id')") {{ $t("ui.campaign_id") }}
                  .float-right 
                    i(:class="changeSortKey('campaign_id')")
                th.text-left(width="7%" @click="sortOrder('target_group')")
                  span(:title="$t('ui.target_group')") {{ $t("ui.target_group") }}
                  .float-right 
                    i(:class="changeSortKey('target_group')")
                th.text-right(width="7%")
                  span(:title="$t('ui.vip_id')") {{ $t("ui.vip") }}
                th.text-center(width="5%" @click="sortOrder('status')")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                  .float-right 
                    i(:class="changeSortKey('status')")
                th.text-right(width="8%")
                  span.d-block(:title="$t('ui.start_date')") {{ $t("ui.start_date") }}
                  span(:title="$t('ui.end_date')") {{ $t("ui.end_date") }}
            tbody.clusterize-content
              tr(v-if="rescueFundList.length == 0")
                td(colspan="15").text-center
                  span {{ $t('message.no_data_available') }}
              template(v-for="(item, index) in rescueFundList")
                tr(:class="$helpers.rowClassBitPromo(item.status)")
                  td.text-center
                    span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                  td
                    span(:title="item.rescue_id") {{ item.rescue_id }}
                  td.text-left
                    span(:title="item.rescue_name") {{ item.rescue_name }}
                  td.text-left
                    span(:title="$t('ui.' + item.rescue_cycle.toLowerCase()).toUpperCase()") {{ $t('ui.' + item.rescue_cycle.toLowerCase()).toUpperCase() }}
                  td.text-right
                    span(:title="item.rescue_rate") {{ item.rescue_rate }}
                  td.text-right
                    span(:title="$n(item.min_deposit, 'currency')") {{ $n(item.min_lose, 'currency') }}
                  td.text-right
                    span(:title="$n(item.max_payout, 'currency')") {{ $n(item.max_payout, 'currency') }}
                  td
                    template(v-if="item.provider_list")
                      a.float-right.pointer(v-if="item.provider_list.split(',').map(p => p.trim()).length > 5" @click="onOffDetail(item)")
                        i.fa(:class="currId == item.rescue_id ? 'fa-minus' : 'fa-plus'")
                      b-badge.mr-1.mb-1(
                        v-for="(provider, i) in (item.provider_list.split(',').map(p => p.trim()).slice(0, 5))"
                        :key="provider"
                        variant="secondary"
                      )
                        | {{ provider }}
                    template(v-else)
                      b-badge {{ $t('ui.all') }}
                  td
                    span(:title="$t('ui.' + item.payout_method.toLowerCase())") {{ $t("ui." + item.payout_method.toLowerCase()) }}
                  td.text-left
                    span(:title="item.campaign_id") {{ item.campaign_id }}
                  td.text-left
                    span(:title="item.target_group") {{ item.target_group }}
                    template(v-if="['CUSTOM'].includes(item.target_group)")
                      br
                      span(v-if="['CUSTOM'].includes(item.target_group)")
                        a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onGetCustomMemberList(item)" :title="$t('ui.edit')")
                  td.text-right
                    span(:title="item.vip_list") {{ item.vip_list }}
                      //- i.fas.fa-crown(v-if="item.vip_name") &nbsp;{{ item.vip_list }}
                  td
                    div.d-flex.justify-content-center.align-items-center
                      label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="changedStatus(item, $event)" :disabled="!isEditAccess")
                        span.custom-switch-indicator
                  td.text-right
                    span.d-block(:title="$moment(item.start_date).format('YYYY-MM-DD')") {{ $moment(item.start_date).format('YYYY-MM-DD') }}
                    span(:title="$moment(item.end_date).format('YYYY-MM-DD')") {{ $moment(item.end_date).format("YYYY-MM-DD") }}
                tr(v-if="isShowDetail == true && currId == item.rescue_id")
                  td(colspan="15")
                    table.table.table-sm.table-bordered.table-striped.table-hover
                      thead.thead-dark
                        tr
                          th
                            span(:title="$t('ui.provider_list')") {{ $t("ui.provider_list") }}
                      tbody.clusterize-content
                        tr
                          td
                            template(v-if="item.provider_list")
                              b-badge.mr-1.mb-1(
                                v-for="(provider, i) in item.provider_list.split(',').map(p => p.trim())"
                                :key="provider"
                                variant="secondary"
                              )
                                | {{ provider }}

  addrescuefund(@clicked="addRescueFund" @failed="handleFailed")
  getcustommemberlist(ref="getcustommemberlist" :item="editSelectedRescueFund" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import addrescuefund from "@/components/rescuefund/addRescueFund.vue";
import getcustommemberlist from "@/components/rescuefund/getCustomMemberList.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addrescuefund,
    getcustommemberlist
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currentPage: 1,
    totalRow: 0,
    sortKey: "rescue_id",
    sortType: "asc",
    search: "",
    rescueFundList: [],
    rescueFundStatus: 1,
    editSelectedRescueFund: null,
    currId: null,
    isShowDetail: false
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeRescueFund;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_rescuefund");
    }
  },
  mounted: function() { },
  methods: {
    onOffDetail(item) {
      if (this.isShowDetail == true) {
        if (this.currId == item.rescue_id) {
          this.isShowDetail = false;
          this.currId = null;
        } else {
          this.isShowDetail = false;
          this.currId = null;
          this.isShowDetail = true;
          this.currId = item.rescue_id;
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.rescue_id;
      }
    },
    refresh() {
      this.getRescueFundList()
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getRescueFundList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeRescueFund", pageSize);
      this.currentPage = 1;
      this.getRescueFundList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getRescueFundList();
    },
    onGetCustomMemberList(e) {
      this.editSelectedRescueFund = e;
      this.$refs.getcustommemberlist.$refs.getCustomMemberList.show();
    },
    addRescueFund: function() {
      this.search = "";
      this.getRescueFundList(true);

      this.$helpers.showDialog(this.$t("ui.combine.add_rescue_fund"), this.$t("message.success"), "success");
    },
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_rescue_fund_status_confirm", { name: item.rescue_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = config.rescueFundStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        rescue_id: item.rescue_id,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getRescueFundList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getRescueFundList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getRescueFundList: function(isSearch) {
      this.currId = null;
      this.isShowDetail = false;
      let url = config.rescueFundListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.search.trim() != '') {
        json.rescue_id = this.search.trim();
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.rescueFundList = response.data.dt;
                this.totalRow = this.rescueFundList.length > 0 ? this.rescueFundList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>